module.exports = __webpack_public_path__ + "img/feat_photo.ed704852.png";